import getConfig from 'next/config';

import { GenerateServiceOSScriptArgs } from './types';

const getLogoUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin + '/assets/images/logo_urban_color.png';
  }

  return 'https://files.serviceos.com/202412032tcZ4SR3BeEiIEmLjk7bZRUClotQSk3PnCn0gD0MS9TxNyDOKtmd';
};

function getServiceOSConfig(locale: string, config: Record<string, string>) {
  const serviceOS = {
    key:
      config.NEXT_PUBLIC_SERVICE_OS_KEY ||
      '8zhl6dflji6qr84t2iy5k57d2gwvn4pruhfpt0nf5621wjp0sxul7tz10x4aam28',
    profile_id: config.NEXT_PUBLIC_SERVICE_OS_PROFILE_ID || 'UK-LONDON',
    api_url: config.NEXT_PUBLIC_SERVICE_OS_API_URL || 'https://urban.serviceos.com/',
    accounts_url: config.NEXT_PUBLIC_SERVICE_OS_ACCOUNTS_URL || 'https://accounts.urban.co/',
    logo_url: config.NEXT_PUBLIC_SERVICE_OS_LOGO_URL || getLogoUrl(),
    main_url: config.NEXT_PUBLIC_SERVICE_OS_MAIN_URL || 'https://urban.co/',
    source_abbr: config.NEXT_PUBLIC_SERVICE_OS_SOURCE_ABBR || 'London_WEB',
    phone: config.NEXT_PUBLIC_SERVICE_OS_PHONE || '01111111111',
    hide_phone: config.NEXT_PUBLIC_SERVICE_OS_HIDE_PHONE
      ? config.NEXT_PUBLIC_SERVICE_OS_HIDE_PHONE === 'true'
      : true,
    disable_profile_selection: config.NEXT_PUBLIC_SERVICE_OS_DISABLE_PROFILE_SELECTION
      ? config.NEXT_PUBLIC_SERVICE_OS_DISABLE_PROFILE_SELECTION === 'true'
      : false,
    website_name: config.NEXT_PUBLIC_SERVICE_OS_WEBSITE_NAME || 'URBAN',
    country: config.NEXT_PUBLIC_SERVICE_OS_COUNTRY || 'UK',
  };

  if (locale === 'fr-fr') {
    serviceOS.profile_id = 'FR-PARIS';
    serviceOS.source_abbr = 'FR_Urban_website';
    serviceOS.phone = '00666666666';
    serviceOS.country = 'FR';
  }

  return serviceOS;
}

export function generateServiceOSScript({ locale }: GenerateServiceOSScriptArgs): string {
  const config = getConfig().publicRuntimeConfig;
  const serviceOS = getServiceOSConfig(locale, config);

  const isProduction =
    process.env.NODE_ENV === 'production' &&
    typeof window !== 'undefined' &&
    !window.location.hostname.includes('staging');

  return `
    var obfOptions = {
      key: '${serviceOS.key}',
      profile_id: '${serviceOS.profile_id}',
      api_url: '${serviceOS.api_url}',
      accounts_url: '${serviceOS.accounts_url}',
      logo_url: '${serviceOS.logo_url}',
      main_url: '${serviceOS.main_url}',
      source_abbr: '${serviceOS.source_abbr}',
      phone: '${serviceOS.phone}',
      hide_phone: ${serviceOS.hide_phone},
      website_name: '${serviceOS.website_name}',
      country: '${serviceOS.country}',
      disable_profile_selection: ${serviceOS.disable_profile_selection},
      theme: {
        'primary-color-lighter': '#ffb800',
        'primary-color-light': '#ffb800',
        'primary-color': '#FAC600',
        'primary-color-dark': '#FAC600',
        'primary-color-darker': '#FAC600',
        'secondary-color-lighter': '#2F3B3F',
        'secondary-color-light': '#2F3B3F',
        'secondary-color': '#2F3B3F',
        'secondary-color-dark': '#2F3B3F',
        'secondary-color-darker': '#2F3B3F',
        'loader-outside-circle': '#FAC600',
        'loader-inside-circle': '#B5C8D4',
        'loader-middle-circle': '#2F3C3F'
      },
      ${
        isProduction
          ? `app_url: '${serviceOS.main_url}obf/'`
          : "get app_url() { return this.accounts_url + 'obf/' }"
      }
      ,
    };

    function async(src) {
      var d = document, t = 'script',
      o = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
      o.src = src;
      try { o.fetchPriority = 'high'; } catch (e) {}
      s.parentNode.insertBefore(o, s);
    };

    async(obfOptions.${isProduction ? 'app_url' : 'accounts_url'} + '${
    isProduction ? '' : 'obf/'
  }client/client.min.js?' + Math.floor(new Date().getTime() / 3600000));
  `;
}
